/**
 * Mobile accordion menu for mega-products navigation.
 * Defines <winess-accordion-item> custom element.
 * Each item expands/collapses inline; only one open at a time.
 */
if (!customElements.get('winess-accordion-item')) {
  class WinessAccordionItem extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.winess-accordion__trigger');
      this.content = this.querySelector('.winess-accordion__content');
      if (!this.trigger || !this.content) return;

      this.trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggle();
      });

      this.trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          this.toggle();
        }
      });
    }

    toggle() {
      const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';

      this.closest('.winess-mobile-accordion')
        ?.querySelectorAll('winess-accordion-item')
        .forEach((item) => {
          if (item !== this) item.close();
        });

      isOpen ? this.close() : this.open();
    }

    open() {
      this.trigger.setAttribute('aria-expanded', 'true');
      this.content.hidden = false;
      this.classList.add('is-open');
    }

    close() {
      this.trigger.setAttribute('aria-expanded', 'false');
      this.content.hidden = true;
      this.classList.remove('is-open');
    }
  }

  customElements.define('winess-accordion-item', WinessAccordionItem);
}
